import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const AppearanceShow18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.99996 5.5C7.06696 5.5 5.49996 7.067 5.49996 9C5.49996 10.933 7.06696 12.5 8.99996 12.5C10.933 12.5 12.5 10.933 12.5 9C12.5 7.067 10.933 5.5 8.99996 5.5ZM6.99996 9C6.99996 7.89543 7.89539 7 8.99996 7C10.1045 7 11 7.89543 11 9C11 10.1046 10.1045 11 8.99996 11C7.89539 11 6.99996 10.1046 6.99996 9Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.99996 2.74249C5.37029 2.74249 3.12342 5.82349 0.78384 8.16307C0.323844 8.62307 0.323844 9.39217 0.78384 9.85217C3.12342 12.1918 5.37028 15.2727 8.99996 15.2727C12.6296 15.2727 14.8765 12.1918 17.2161 9.85217C17.6761 9.39217 17.6761 8.62307 17.2161 8.16307C14.8765 5.82349 12.6296 2.74249 8.99996 2.74249ZM8.99996 4.24249C12.0319 4.24249 13.9916 7.05992 15.9393 9.00762C13.9916 10.9553 12.0319 13.7727 8.99996 13.7727C5.96797 13.7727 4.00831 10.9553 2.06061 9.00762C4.00831 7.05992 5.96797 4.24249 8.99996 4.24249Z'
      fill='currentColor'
    />
  </Svg>
);

AppearanceShow18.displayName = 'AppearanceShow18';
export default AppearanceShow18;
